import React from "react";
import {
    makeStyles,
    colors,
    Paper,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Toolbar, Typography, IconButton, Tooltip, Select, MenuItem,
    TablePagination, TextField, InputLabel, FormControl, Button,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar,
    CircularProgress, Chip, Box,
    Grid,
    CssBaseline
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import DescriptionIcon from "@material-ui/icons/Description";
import AssessmentIcon from "@material-ui/icons/Assessment";
import SaveIcon from "@material-ui/icons/Save";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorIcon from "@material-ui/icons/Error";
import InfoIcon from "@material-ui/icons/Info";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import * as XLSX from "xlsx";
import { Alert, AlertTitle } from "@material-ui/lab";
import { useStylesUiElemment } from "../../../../../St/comps/UseStyle";
import { BeatLoader } from "react-spinners";

const useStyles = makeStyles((theme) => ({
    root: {
        paddingBottom: theme.spacing(3),
        minHeight: "100%",

    },
    headCell: {
        border: "solid 0.6px black",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 15,
        color: "#fff",
        position: "sticky",
        top: 0,
        background: "linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%)", // تدرج وردي فاتح
        zIndex: 1
    },
    rowCell: {
        borderBottom: "solid 0.5px gray",
        fontFamily: "Amiri-Regular",
        fontWeight: 700,
        fontSize: 14,
        color: "#000",
        whiteSpace: "nowrap"
    },
    evenRow: {
        background: "linear-gradient(135deg, #ffe6e6 0%, #ffcccc 100%)" // تدرج وردي فاتح جداً
    },
    oddRow: {
        background: "linear-gradient(135deg, #fff0f0 0%, #ffe6e6 100%)" // تدرج أبيض وردي فاتح
    },
    clickableRow: {
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
            background: "linear-gradient(135deg, #ffb3b3 0%, #ff9999 100%) !important", // تدرج وردي فاتح عند التمرير
            transform: "scale(1.01)",
            boxShadow: "0 4px 8px rgba(255, 153, 153, 0.3)"
        }
    },
    saveButton: {
        background: "linear-gradient(135deg, #4caf50 0%, #45a049 50%, #388e3c 100%)",
        color: "white",
        margin: "0 5px",
        boxShadow: "0 4px 15px rgba(76, 175, 80, 0.4)",
        transition: "all 0.3s ease",
        "&:hover": {
            background: "linear-gradient(135deg, #45a049 0%, #388e3c 50%, #2e7d32 100%)",
            transform: "scale(1.05)",
            boxShadow: "0 6px 20px rgba(76, 175, 80, 0.6)"
        }
    },
    dialogTitle: {
        background: "linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%)",
        color: "white",
        textAlign: "center",
        fontFamily: "Amiri-Regular",
        fontWeight: 700
    },
    dialogContent: {
        fontFamily: "Amiri-Regular",
        direction: "rtl"
    },
    statsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "15px",
        marginBottom: "20px"
    },
    statCard: {
        background: "linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%)",
        color: "white",
        padding: "15px",
        borderRadius: "10px",
        textAlign: "center",
        boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
    },
    statNumber: {
        fontSize: "1.8em",
        fontWeight: 700,
        marginBottom: "5px"
    },
    statLabel: {
        fontSize: "0.9em",
        opacity: 0.9
    },
    chip: {
        margin: "5px",
        fontFamily: "Amiri-Regular"
    },
    progressContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px"
    },
    progressText: {
        marginTop: "15px",
        fontFamily: "Amiri-Regular",
        fontSize: "1.1em",
        color: "#cd5c5c"
    }
}));

export default function ImportExcel(props) {
    const { isPurches, isStock, isItem, isSales, getFormExcelData,
        excelData, setExcelData, loadingExcel, setValue
    } = props;

    const classes = useStyles();
    const [wb, setWb] = React.useState(null);             // Workbook
    const [sheetNames, setSheetNames] = React.useState([]);
    const [sheet, setSheet] = React.useState("");
    // const [rows, setRows] = React.useState([]);           // Array of objects
    const [cols, setCols] = React.useState([]);           // Column keys
    const [orderBy, setOrderBy] = React.useState("");
    const [order, setOrder] = React.useState("asc");
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [q, setQ] = React.useState("");

    // States for save functionality
    const [openSaveDialog, setOpenSaveDialog] = React.useState(false);
    const [saveProgress, setSaveProgress] = React.useState(false);
    const [saveComplete, setSaveComplete] = React.useState(false);
    const [validationResults, setValidationResults] = React.useState(null);
    const [snackbar, setSnackbar] = React.useState({ open: false, message: "", severity: "info" });

    const headerBg = isSales ? "#4e9e84" : isPurches ? "#008080" : isStock ? "#3f51b5" : "linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%)"; // تدرج وردي فاتح

    const styleButton = isSales ? 'linear-gradient(135deg, #4e9e84 0%, #4e9e84 50%, #4e9e84 100%)' :
        isPurches ? 'linear-gradient(135deg, #3f51b5 0%, #3f51b5 50%, #3f51b5 100%)' :
            isStock ? 'linear-gradient(135deg, #3f51b5 0%, #3f51b5 50%, #3f51b5 100%)' :
                'linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%)';

    const styleRow1 = isSales ? "linear-gradient(135deg, #e8f5e9 0%, #e8f5e9 100%)" :
        isPurches ? "linear-gradient(135deg, #e3f2fd 0%, #e3f2fd 100%)" :
            isStock ? "linear-gradient(135deg, #e3f2fd 0%, #e3f2fd 100%)" :
                "linear-gradient(135deg, #ffe6e6 0%, #ffcccc 100%)";
    const styleRow2 = isSales ? "linear-gradient(135deg, #81c784 0%, #81c784 100%)" :
        isPurches || isStock ? "linear-gradient(135deg, #64b5f6 0%, #64b5f6 100%)" :
            "linear-gradient(135deg, #fff0f0 0%, #ffe6e6 100%)"

    React.useEffect(() => {
        // عدّل لون الرأس حسب النوع
        const el = document.documentElement;
        el.style.setProperty("--header-bg", headerBg);
    }, [headerBg]);

    const handleFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const buf = await file.arrayBuffer();
        const _wb = XLSX.read(buf, { type: "array" });
        setWb(_wb);
        setSheetNames(_wb.SheetNames || []);
        const first = _wb.SheetNames?.[0];
        setSheet(first || "");
        if (first) loadSheet(_wb, first);
    };

    const loadSheet = (workbook, sheetName) => {
        const ws = workbook.Sheets[sheetName];
        if (!ws) return;
        const json = XLSX.utils.sheet_to_json(ws, { defval: "", raw: true });
        // setRows(json);
        setExcelData(json);
        const keys = json.length ? Object.keys(json[0]) : [];
        setCols(keys);
        setOrderBy(""); setOrder("asc");
        setPage(0);
        // console.log("the data is", json)

    };

    const handleSheetChange = (e) => {
        const name = e.target.value;
        setSheet(name);
        if (wb) loadSheet(wb, name);
    };

    const handleSort = (key) => {
        if (orderBy === key) {
            setOrder(order === "asc" ? "desc" : "asc");
        } else {
            setOrderBy(key);
            setOrder("asc");
        }
    };

    const normalized = (v) => (v ?? "").toString().toLowerCase();
    const filtered = React.useMemo(() => {
        if (!q) return excelData;
        const nq = q.toLowerCase();
        return excelData.filter(r => cols.some(c => normalized(r[c]).includes(nq)));
    }, [excelData, q, cols]);

    const sorted = React.useMemo(() => {
        if (!orderBy) return filtered;
        const copy = [...filtered];
        copy.sort((a, b) => {
            const va = a[orderBy];
            const vb = b[orderBy];
            if (va === vb) return 0;

            // رقمياً إن أمكن
            const na = typeof va === "number" || !isNaN(parseFloat(va));
            const nb = typeof vb === "number" || !isNaN(parseFloat(vb));
            const av = na ? parseFloat(va) : (va ?? "").toString();
            const bv = nb ? parseFloat(vb) : (vb ?? "").toString();

            if (av < bv) return order === "asc" ? -1 : 1;
            if (av > bv) return order === "asc" ? 1 : -1;
            return 0;
        });
        return copy;
    }, [filtered, orderBy, order]);

    // دالة فحص البيانات
    const validateData = () => {
        if (!excelData.length) {
            return {
                valid: false,
                message: "لا توجد بيانات للفحص"
            };
        }

        const results = {
            totalItems: excelData.length,
            validItems: 0,
            duplicateItems: 0,
            invalidItems: 0,
            missingFields: 0,
            warnings: [],
            errors: [],
            duplicates: []
        };

        // فحص البيانات المكررة
        const seen = new Set();
        const duplicates = [];


        excelData.forEach((row, index) => {
            // فحص الحقول المطلوبة (افترض أن العمود الأول هو المعرف)
            const keyField = cols[0];
            const keyValue = row[keyField];

            if (!keyValue || keyValue.toString().trim() === "") {
                results.missingFields++;
                results.warnings.push(`الصف ${index + 1}: حقل ${keyField} فارغ`);
            }

            // فحص التكرار
            if (keyValue && seen.has(keyValue.toString())) {
                results.duplicateItems++;
                duplicates.push({ row: index + 1, value: keyValue });
                results.errors.push(`الصف ${index + 1}: قيمة مكررة (${keyValue})`);
            } else if (keyValue) {
                seen.add(keyValue.toString());
            }

            // فحص صحة البيانات
            let isValid = true;
            cols.forEach(col => {
                const value = row[col];
                if (value === null || value === undefined || value === "") {
                    isValid = false;
                }
            });

            if (isValid) {
                results.validItems++;
            } else {
                results.invalidItems++;
            }
        });

        results.duplicates = duplicates;
        results.valid = results.validItems > 0;

        return results;
    };
    const validateDataItems = () => {
        if (!excelData.length) {
            return {
                valid: false,
                message: "لا توجد بيانات للفحص"
            };
        }
        const isEmpity = val => val == null || val.toString().trim() === "" || val === undefined;
        const keys = Object.keys(excelData[0]);
        const seen = new Set();

        const header = ["name", "nameE", "barcode", "group_name", "unit_name", "perc", "purch_price", "sale_price", "min_price", "Distributor_price",
            "jomla_price", "beg_date", "end_date", "tax", "discount", "min_val", "safe", "val"];
        const actiolItems = excelData.map(row => {
            const values = keys.map(k => row[k]);
            const obj = {};
            header.forEach((key, i) => {
                obj[key] = values[i];
            });
            return obj
        });
        const realItem = actiolItems.filter(item => {
            if (seen.has(item.barcode)) {
                return false;
            }
            seen.add(item.barcode);
            return true;
        });
        const results = {
            totalItems: excelData.length,
            total_real: realItem.length,
            validItems: 0,
            duplicateItems: 0,
            invalidItems: 0,
            missingFields: 0,
            warnings: [],
            errors: [],
            empity: [],
            duplicates: []
        };
        // فحص البيانات المكررة
        const duplicates = [];

        actiolItems.forEach((row, index) => {
            // فحص الحقول المطلوبة (افترض أن العمود الأول هو المعرف)
            const keyField = cols[0];
            const keyValue = row[keyField];
            // فحص التكرار
            if (keyValue && seen.has(row.barcode)) {
                results.duplicateItems++;
                duplicates.push({ row: index + 1, value: keyValue });
                results.errors.push(`الصف ${index + 1}: قيمة مكررة (${keyValue})`);
            } else if (keyValue) {
                seen.add(keyValue.toString());
            }

            if (isEmpity(row.name) || isEmpity(row.barcode) || isEmpity(row.perc) || isEmpity(row.purch_price) || isEmpity(row.sale_price)
                || isEmpity(row.min_price) || isEmpity(row.Distributor_price) || isEmpity(row.jomla_price) || isEmpity(row.tax)) {
                results.missingFields++;
                results.empity.push(`الصف ${index + 1}: حقل ${keyField} فارغ`);
            }
            // فحص صحة البيانات
            let isValid = true;
            cols.forEach(col => {
                const value = row[col];
                if (value === null || value === undefined || value === "") {
                    isValid = false;
                }
            });
        });

        results.duplicates = duplicates;
        results.valid = results.validItems > 0;

        return results;
    };
    // دالة فتح نافذة الحفظ
    const handleSaveClick = () => {
        const validation = validateDataItems();
        setValidationResults(validation);
        setOpenSaveDialog(true);
    };

    // دالة تنفيذ الحفظ
    const handleSaveConfirm = async () => {
        // محاكاة عملية الحفظ
        // await new Promise(resolve => setTimeout(resolve, 2000));
        try {
            setOpenSaveDialog(false);
            await getFormExcelData();
            // إغلاق النافذة بعد ثانيتين  
            // setSaveProgress(true);
            // setSaveProgress(false);
            // setSaveComplete(true);
            // إظهار رسالة نجاح
            setSnackbar({
                open: true,
                // message: `تم حفظ ${validationResults.validItems} صنف بنجاح! 🎉`,
                message: `Please Wait.......`,
                severity: "success"
            });
            setTimeout(() => {
                setOpenSaveDialog(false);
                // setSaveComplete(false);
                setValidationResults(null);
            }, 2000);
        }catch{}

    };

    // دالة إغلاق النافذة
    const handleCloseDialog = () => {
        if (!saveProgress) {
            setOpenSaveDialog(false);
            setSaveComplete(false);
            setValidationResults(null);
        }
    };

    // دالة إغلاق الرسالة
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const paged = React.useMemo(() => {
        const start = page * rowsPerPage;
        return sorted.slice(start, start + rowsPerPage);
    }, [sorted, page, rowsPerPage]);

    const onRowClick = (row) => {
        // هنا نفس سلوكك السابق إن أردت فتح تفاصيل/إدخال
        // console.log("row", row);
    };

    const headCellStyle = { ...classes.headCell, background: headerBg };

    const printTable = () => {
        // طباعة تقرير رائع ومرتب وذو ألوان
        const w = window.open("", "_blank");
        const currentDate = new Date().toLocaleDateString('ar-SA', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long'
        });
        const currentTime = new Date().toLocaleTimeString('ar-SA');

        // حساب إحصائيات إضافية
        const numericColumns = cols.filter(col =>
            sorted.some(row => typeof row[col] === 'number' || !isNaN(parseFloat(row[col])))
        );

        const totalSum = numericColumns.reduce((sum, col) => {
            return sum + sorted.reduce((colSum, row) => {
                const val = parseFloat(row[col]);
                return colSum + (isNaN(val) ? 0 : val);
            }, 0);
        }, 0);

        const tableHtml = `
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <meta charset="UTF-8">
        <title>تقرير استيراد الأصناف</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap');
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Amiri', serif;
            margin: 0;
            padding: 20px;
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: #333;
            direction: rtl;
          }
          
          .print-container {
            background: white;
            border-radius: 15px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.1);
            overflow: hidden;
            margin: 0 auto;
            max-width: 1200px;
          }
          
          .header {
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: white;
            padding: 30px;
            text-align: center;
            position: relative;
          }
          
          .header::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="white" opacity="0.1"/><circle cx="75" cy="75" r="1" fill="white" opacity="0.1"/><circle cx="50" cy="10" r="0.5" fill="white" opacity="0.1"/><circle cx="10" cy="60" r="0.5" fill="white" opacity="0.1"/><circle cx="90" cy="40" r="0.5" fill="white" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
            opacity: 0.3;
          }
          
          .header h1 {
            font-size: 2.5em;
            font-weight: 700;
            margin-bottom: 10px;
            text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
            position: relative;
            z-index: 1;
          }
          
          .header .subtitle {
            font-size: 1.2em;
            opacity: 0.9;
            margin-bottom: 15px;
            position: relative;
            z-index: 1;
          }
          
          .header .date-time {
            font-size: 1em;
            opacity: 0.8;
            position: relative;
            z-index: 1;
          }
          
          .content {
            padding: 30px;
          }
          
          .stats {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
            margin-bottom: 30px;
          }
          
          .stat-card {
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: white;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }
          
          .stat-number {
            font-size: 2em;
            font-weight: 700;
            margin-bottom: 5px;
          }
          
          .stat-label {
            font-size: 1em;
            opacity: 0.9;
          }
          
          .table-container {
            background: white;
            border-radius: 10px;
            overflow: hidden;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          }
          
          .table-header {
            background: linear-gradient(135deg, #cd5c5c 0%, #b22222 50%, #8b0000 100%);
            color: white;
            padding: 15px;
            text-align: center;
            font-weight: bold;
            border-radius: 8px 8px 0 0;
          }
          
          .table-header h2 {
            font-size: 1.5em;
            font-weight: 700;
            margin: 0;
          }
          
          table {
            width: 100%;
            border-collapse: collapse;
            font-family: 'Amiri', serif;
          }
          
          thead th {
            background: linear-gradient(135deg, #cd5c5c 0%, #b22222 50%, #8b0000 100%);
            color: white;
            padding: 12px;
            text-align: center;
            font-weight: bold;
            border: 1px solid #ddd;
          }
          
          tbody tr:nth-child(even) {
            background: linear-gradient(135deg, #ffb3b3 0%, #ff8080 100%);
          }
          
          tbody tr:nth-child(odd) {
            background: linear-gradient(135deg, #ffcccb 0%, #ffa07a 100%);
          }
          
          tbody tr:hover {
            background: linear-gradient(135deg, #ff6b6b 0%, #ff6347 100%);
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          tbody td {
            padding: 12px 10px;
            text-align: center;
            border: 1px solid #ddd;
            font-size: 1em;
            font-weight: 500;
          }
          
          .footer {
            background: linear-gradient(135deg, #cd5c5c 0%, #b22222 50%, #8b0000 100%);
            color: white;
            padding: 20px;
            text-align: center;
            margin-top: 30px;
            border-radius: 0 0 8px 8px;
          }
          
          @media print {
            body {
              background: white;
              padding: 0;
            }
            
            .print-container {
              box-shadow: none;
              border-radius: 0;
            }
            
            .header, .footer {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            thead th {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            .stat-card {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            tbody tr:nth-child(even) {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
            
            tbody tr:nth-child(odd) {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        <div class="print-container">
          <div class="header">
            <h1>📊 تقرير استيراد الأصناف</h1>
            <div class="subtitle">نظام إدارة المخزون والمنتجات</div>
            <div class="date-time">📅 ${currentDate} | 🕐 ${currentTime}</div>
          </div>
          
          <div class="content">
            <div class="stats">
              <div class="stat-card">
                <div class="stat-number">${sorted.length}</div>
                <div class="stat-label">إجمالي الأصناف</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">${cols.length}</div>
                <div class="stat-label">عدد الأعمدة</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">${sheet || 'غير محدد'}</div>
                <div class="stat-label">اسم الورقة</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">${new Date().getFullYear()}</div>
                <div class="stat-label">سنة التقرير</div>
              </div>
              <div class="stat-card">
                <div class="stat-number">${totalSum.toLocaleString('ar-SA')}</div>
                <div class="stat-label">إجمالي القيم الرقمية</div>
              </div>
            </div>
            
            <div class="table-container">
              <div class="table-header">
                <h2>📋 تفاصيل الأصناف المستوردة</h2>
              </div>
              <table>
          <thead>
                  <tr>
                    ${cols.map(c => `<th>${c}</th>`).join("")}
                  </tr>
          </thead>
          <tbody>
                  ${sorted.map((r, index) => `
                    <tr>
                      ${cols.map(c => `<td>${formatCellForPrint(r[c])}</td>`).join("")}
                    </tr>
                  `).join("")}
          </tbody>
        </table>
            </div>
          </div>
          
          <div class="footer">
            <p>🖨️ تم إنشاء هذا التقرير بواسطة نظام إدارة المخزون | 📧 للاستفسارات: info@company.com</p>
          </div>
        </div>
      </body>
      </html>`;

        w.document.write(tableHtml);
        w.document.close();
        w.focus();
        w.print();
    };

    // دالة تنسيق خاصة للطباعة
    const formatCellForPrint = (v) => {
        if (v == null || v === "") return "-";
        if (v instanceof Date) return v.toLocaleDateString('ar-SA');
        if (typeof v === "number") {
            return Number.isInteger(v) ? v.toLocaleString('ar-SA') : v.toFixed(2);
        }
        return String(v);
    };

    // دالة طباعة ملخص سريع
    const printSummary = () => {
        const w = window.open("", "_blank");
        const currentDate = new Date().toLocaleDateString('ar-SA', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });

        const numericColumns = cols.filter(col =>
            sorted.some(row => typeof row[col] === 'number' || !isNaN(parseFloat(row[col])))
        );

        const summaryHtml = `
      <!DOCTYPE html>
      <html dir="rtl" lang="ar">
      <head>
        <meta charset="UTF-8">
        <title>ملخص استيراد الأصناف</title>
        <style>
          @import url('https://fonts.googleapis.com/css2?family=Amiri:wght@400;700&display=swap');
          
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }
          
          body {
            font-family: 'Amiri', serif;
            margin: 0;
            padding: 20px;
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: #333;
            direction: rtl;
          }
          
          .summary-container {
            background: white;
            border-radius: 15px;
            box-shadow: 0 20px 40px rgba(0,0,0,0.1);
            overflow: hidden;
            margin: 0 auto;
            max-width: 800px;
          }
          
          .header {
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: white;
            padding: 30px;
            text-align: center;
            position: relative;
          }
          
          .header h1 {
            font-size: 2em;
            font-weight: 700;
            margin-bottom: 10px;
          }
          
          .content {
            padding: 30px;
          }
          
          .summary-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
            margin-bottom: 30px;
          }
          
          .summary-card {
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: white;
            padding: 20px;
            border-radius: 10px;
            text-align: center;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }
          
          .summary-number {
            font-size: 2.5em;
            font-weight: 700;
            margin-bottom: 5px;
          }
          
          .summary-label {
            font-size: 1.1em;
            opacity: 0.9;
          }
          
          .footer {
            background: linear-gradient(135deg, #ff9999 0%, #ff8080 50%, #ff6666 100%);
            color: white;
            padding: 20px;
            text-align: center;
            margin-top: 30px;
            border-radius: 0 0 8px 8px;
          }
          
          @media print {
            body {
              background: white;
              padding: 0;
            }
            
            .summary-container {
              box-shadow: none;
              border-radius: 0;
            }
            
            .header, .footer, .summary-card {
              -webkit-print-color-adjust: exact;
              color-adjust: exact;
            }
          }
        </style>
      </head>
      <body>
        <div class="summary-container">
          <div class="header">
            <h1>📊 ملخص استيراد الأصناف</h1>
            <div>📅 ${currentDate}</div>
          </div>
          
          <div class="content">
            <div class="summary-grid">
              <div class="summary-card">
                <div class="summary-number">${sorted.length}</div>
                <div class="summary-label">إجمالي الأصناف</div>
              </div>
              <div class="summary-card">
                <div class="summary-number">${cols.length}</div>
                <div class="summary-label">عدد الأعمدة</div>
              </div>
              <div class="summary-card">
                <div class="summary-number">${numericColumns.length}</div>
                <div class="summary-label">أعمدة رقمية</div>
              </div>
              <div class="summary-card">
                <div class="summary-number">${sheet || 'غير محدد'}</div>
                <div class="summary-label">اسم الورقة</div>
              </div>
            </div>
            
            <div style="text-align: center; margin-top: 30px;">
              <h3 style="color: #cd5c5c; margin-bottom: 15px;">📋 تفاصيل إضافية</h3>
              <p style="font-size: 1.1em; line-height: 1.6;">
                تم استيراد <strong>${sorted.length}</strong> صنف من ملف Excel<br>
                يحتوي الملف على <strong>${cols.length}</strong> عمود من البيانات<br>
                تم تحليل البيانات بنجاح وإعدادها للطباعة
              </p>
            </div>
          </div>
          
          <div class="footer">
            <p>🖨️ ملخص سريع - نظام إدارة المخزون</p>
          </div>
        </div>
      </body>
      </html>`;

        w.document.write(summaryHtml);
        w.document.close();
        w.focus();
        w.print();
    };
    const clasui = useStylesUiElemment();

    return (
        <>

            <Paper elevation={2}>

                <Toolbar style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                    <Tooltip title="اختر ملف Excel (.xlsx / .xls)">
                        <label style={{ display: "inline-flex", alignItems: "center", gap: 8, cursor: "pointer" }}>
                            <DescriptionIcon />
                            <input
                                type="file"
                                accept=".xlsx,.xls,.csv"
                                style={{ display: "none" }}
                                disabled={loadingExcel}
                                onChange={handleFile}
                            />
                            <Typography variant="body1">تحميل ملف</Typography>
                        </label>
                    </Tooltip>
                    {(!!sheetNames.length) && (

                        <FormControl variant="outlined" size="small">
                            <InputLabel id="sheet-label">الورقة</InputLabel>
                            <Select
                                labelId="sheet-label"
                                value={sheet}
                                onChange={handleSheetChange}
                                label="الورقة"
                                style={{ minWidth: 160 }}
                            >
                                {sheetNames.map(n => <MenuItem key={n} value={n}>{n}</MenuItem>)}
                            </Select>
                        </FormControl>
                    )}
                    <TextField
                        variant="outlined"
                        size="small"
                        label="بحث"
                        value={q}
                        disabled={loadingExcel}
                        onChange={e => setQ(e.target.value)}
                    />

                    {/* <div style={{ flex: 1 }} /> */}

                    {/* زر الحفظ */}
                    {excelData.length > 0 && (
                        <Tooltip title="حفظ وإدخال إلى الجدول">
                            <IconButton
                                // onClick={handleSaveClick}
                                disabled={loadingExcel}
                                onClick={() => (isSales || isPurches || isStock) ? getFormExcelData() : handleSaveClick(1)}
                                className={classes.saveButton}
                            >
                                <SaveIcon />
                            </IconButton>
                        </Tooltip>
                    )}

                    <Tooltip title="طباعة ملخص سريع">
                        <IconButton
                            onClick={printSummary}
                            disabled={loadingExcel}
                            style={{
                                background: styleButton,
                                color: 'white',
                                margin: '0 5px',
                                boxShadow: '0 4px 15px rgba(255, 153, 153, 0.4)',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <AssessmentIcon />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="طباعة تقرير رائع ومرتب">
                        <IconButton
                            onClick={printTable}
                            disabled={loadingExcel}
                            style={{
                                background: styleButton,
                                color: 'white',
                                margin: '0 5px',
                                boxShadow: '0 4px 15px rgba(255, 153, 153, 0.4)',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <PrintIcon />
                        </IconButton>
                    </Tooltip>
                </Toolbar>
                <Grid container justifyContent="center">
                    <Grid item container justifyContent="center" xs={12}>
                        <BeatLoader loading={loadingExcel} color={colors.green[700]} />
                        {!loadingExcel &&
                            <TableContainer maxWidth={true} component={Paper} style={{ minWidth: "100vw" }} >
                                <Table size="small" aria-label="excel preview table">
                                    <TableHead>
                                        <TableRow
                                            style={{
                                                backgroundColor: headerBg,
                                                color: "#000",
                                                fontWeight: 800,
                                                fontFamily: "Amiri-Regular",
                                                fontSize: 15,
                                                border: "solid 0.6px"
                                            }}
                                        >
                                            {cols.length === 0 ? (
                                                <TableCell className={classes.headCell} align="center" style={{ background: headerBg }}>
                                                    حمّل ملف Excel أولاً
                                                </TableCell>
                                            ) : cols.map((c) => (
                                                <TableCell
                                                    key={c}
                                                    className={classes.headCell}
                                                    style={{ background: headerBg, userSelect: "none" }}
                                                    align="center"
                                                    onClick={() => handleSort(c)}
                                                >
                                                    {c}{orderBy === c ? (order === "asc" ? " ▲" : " ▼") : ""}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {paged.map((row, idx) => (
                                            <TableRow
                                                key={idx}
                                                hover
                                                className={classes.clickableRow}
                                                onClick={() => onRowClick(row)}
                                                style={{
                                                    border: "solid 0.6px",
                                                    background: idx % 2 === 0 ? styleRow1 : styleRow2
                                                }}
                                            >
                                                {cols.map((c) => (
                                                    <TableCell key={c} className={classes.rowCell} align="center">
                                                        {formatCell(row[c])}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}

                                        {cols.length > 0 && paged.length === 0 && (
                                            <TableRow>
                                                <TableCell align="center" colSpan={cols.length} style={{ padding: 24 }}>
                                                    لا توجد نتائج مطابقة لبحثك
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        }
                    </Grid>
                </Grid>
                <TablePagination
                    component="div"
                    count={sorted.length}
                    page={page}
                    onPageChange={(_, p) => setPage(p)}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    labelRowsPerPage="صفوف/صفحة"
                />
            </Paper>

            {/* نافذة فحص البيانات */}
            <Dialog
                open={openSaveDialog}
                onClose={handleCloseDialog}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    style: {
                        borderRadius: 15,
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle className={classes.dialogTitle}>
                    {saveComplete ? (
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <CheckCircleIcon style={{ marginRight: 10, fontSize: 30 }} />
                            تم الحفظ بنجاح! 🎉
                        </Box>
                    ) : saveProgress ? (
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <CircularProgress size={30} style={{ marginRight: 10, color: 'white' }} />
                            جاري الحفظ...
                        </Box>
                    ) : (
                        <Box display="flex" alignItems="center" justifyContent="center">
                            <InfoIcon style={{ marginRight: 10, fontSize: 30 }} />
                            فحص البيانات قبل الحفظ
                        </Box>
                    )}
                </DialogTitle>

                <DialogContent className={classes.dialogContent}>
                    {saveComplete ? (
                        <div className={classes.progressContainer}>
                            <CheckCircleIcon style={{ fontSize: 80, color: '#4caf50', marginBottom: 20 }} />
                            <Typography variant="h5" style={{ color: '#4caf50', marginBottom: 10 }}>
                                تم الحفظ بنجاح! 🎉
                            </Typography>
                            <Typography variant="body1">
                                تم حفظ {validationResults?.validItems} صنف في قاعدة البيانات
                            </Typography>
                        </div>
                    ) : saveProgress ? (
                        <div className={classes.progressContainer}>
                            <CircularProgress size={80} style={{ marginBottom: 20 }} />
                            <Typography className={classes.progressText}>
                                جاري حفظ البيانات في قاعدة البيانات...
                            </Typography>
                        </div>
                    ) : validationResults ? (
                        <div>
                            {/* إحصائيات سريعة */}
                            <div className={classes.statsGrid}>
                                <div className={classes.statCard}>
                                    <div className={classes.statNumber}>{validationResults.totalItems}</div>
                                    <div className={classes.statLabel}>إجمالي الأصناف</div>
                                </div>
                                <div className={classes.statCard}>
                                    <div className={classes.statNumber}>{validationResults.validItems}</div>
                                    <div className={classes.statLabel}>أصناف صحيحة</div>
                                </div>
                                <div className={classes.statCard}>
                                    <div className={classes.statNumber}>{validationResults.duplicateItems}</div>
                                    <div className={classes.statLabel}>أصناف مكررة</div>
                                </div>
                                <div className={classes.statCard}>
                                    <div className={classes.statNumber}>{validationResults.missingFields}</div>
                                    <div className={classes.statLabel}>حقول فارغة</div>
                                </div>
                            </div>

                            {/* التنبيهات */}
                            {validationResults.errors.length > 0 && (
                                <Alert severity="error" style={{ marginBottom: 15 }}>
                                    <AlertTitle>أخطاء يجب إصلاحها</AlertTitle>
                                    {validationResults.errors.slice(0, 3).map((error, index) => (
                                        <div key={index}>• {error}</div>
                                    ))}
                                    {validationResults.errors.length > 3 && (
                                        <div>... و {validationResults.errors.length - 3} خطأ آخر</div>
                                    )}
                                </Alert>
                            )}

                            {validationResults.warnings.length > 0 && (
                                <Alert severity="warning" style={{ marginBottom: 15 }}>
                                    <AlertTitle>تحذيرات</AlertTitle>
                                    {validationResults.warnings.slice(0, 3).map((warning, index) => (
                                        <div key={index}>• {warning}</div>
                                    ))}
                                    {validationResults.warnings.length > 3 && (
                                        <div>... و {validationResults.warnings.length - 3} تحذير آخر</div>
                                    )}
                                </Alert>
                            )}

                            {/* البيانات المكررة */}
                            {validationResults.duplicates.length > 0 && (
                                <Box mb={2}>
                                    <Typography variant="h6" style={{ marginBottom: 10, color: '#cd5c5c' }}>
                                        البيانات المكررة:
                                    </Typography>
                                    <Box display="flex" flexWrap="wrap">
                                        {validationResults.duplicates.slice(0, 5).map((dup, index) => (
                                            <Chip
                                                key={index}
                                                label={`الصف ${dup.row}: ${dup.value}`}
                                                color="secondary"
                                                className={classes.chip}
                                            />
                                        ))}
                                        {validationResults.duplicates.length > 5 && (
                                            <Chip
                                                label={`و ${validationResults.duplicates.length - 5} آخر`}
                                                variant="outlined"
                                                className={classes.chip}
                                            />
                                        )}
                                    </Box>
                                </Box>

                            )}

                            {/* رسالة التأكيد */}
                            <Alert severity="info">
                                <AlertTitle>ملاحظة</AlertTitle>
                                سيتم حفظ {validationResults.total_real} صنف صحيح فقط.
                                {validationResults.duplicateItems > 0 && ` سيتم تجاهل ${validationResults.duplicateItems} صنف مكرر.`}
                            </Alert>
                        </div>
                    ) : null}
                </DialogContent>

                <DialogActions style={{ padding: 20, justifyContent: 'center' }}>
                    {!saveProgress && !saveComplete && (
                        <>
                            <Button
                                onClick={handleCloseDialog}
                                variant="outlined"
                                style={{ marginRight: 10 }}
                            >
                                إلغاء
                            </Button>
                            <Button
                                onClick={handleSaveConfirm}
                                variant="contained"
                                className={classes.saveButton}
                                disabled={!validationResults?.empity}
                            >
                                <SaveIcon style={{ marginRight: 8 }} />
                                حفظ {validationResults?.total_real} صنف
                            </Button>
                        </>
                    )}
                </DialogActions>
            </Dialog>

            {/* رسائل التنبيه */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={handleCloseSnackbar}
                    severity={snackbar.severity}
                    style={{ fontFamily: 'Amiri-Regular' }}
                >
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}

// تنسيق خلية ذكي بسيط للأرقام/التواريخ
function formatCell(v) {
    if (v == null) return "";
    // تواريخ Excel قد تصل ككائنات Date بعد التحويل أو كنصوص
    if (v instanceof Date) return v.toLocaleDateString();
    // أرقام طويلة: أظهر بدون قص غير ضروري
    if (typeof v === "number") return Number.isInteger(v) ? v : v.toFixed(2);
    return String(v);
}
